import { render, staticRenderFns } from "./RiskCheckDailySafetyLogAlwaysCreate.vue?vue&type=template&id=ba358c3e&scoped=true&"
import script from "./RiskCheckDailySafetyLogAlwaysCreate.vue?vue&type=script&lang=js&"
export * from "./RiskCheckDailySafetyLogAlwaysCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba358c3e",
  null
  
)

export default component.exports